
import 'datatables.net/js/jquery.dataTables';
import 'datatables.net-responsive/js/dataTables.responsive';

(function () {

    var resourceMini = $('.js-datatables--advnc-resource-table');

    if (!resourceMini.length) {
        return;
    }

    resourceMini.each(function () {
        var _self = $(this);

        _self.DataTable({
            columnDefs: [
                {
                    targets: 'no-sort',
                    orderable: false,
                    order: [],
                },
            ],
            pageLength: 12,
            paging: false,
            info: false,
            responsive: true,
            searching: false,
        });
    })

}());
